import type { IconConfig } from '../../utils'

import type { ImageDimension } from './blocks'
import type { IMAGE_PURPOSE } from './enums'
import type { ImageId } from './ids'

/**
 * Used to determine the render-style of image choices
 */
export enum IMAGE_CHOICE_UI_SUBTYPE {
  INFOGRAPHIC = 'infographic',
  ICON = 'icon'
}

/**
 * Represents a basic choice, intentionally designed to be extended for additional functionality.
 * This is currently used in Single and Multiple Choice blocks.
 */
export interface Choice {
  /**
   * Raw value of a given choice, can be a string or number
   */
  value: string
  /**
   * Human-friendly label
   */
  label?: string | null
}

export interface IconChoice extends Choice {
  /**
   * An icon to help convey what this choice is about
   */
  icon?: IconConfig
}

export interface ImageChoice extends IconChoice, Choice {
  image?: {
    id: ImageId
    /** Indicates the purpose of the image for accessibility reasons */
    purpose: IMAGE_PURPOSE
    /** From which URL to load this image from */
    url: string
    /**
     * Original dimensions of the given image, useful for responsiveness
     * and progressive enhancement features
     */
    dimensions?: ImageDimension
    /**
     * Alternative text for the given image, in case {@link ImageChoice.image.purpose}
     * is not {@link IMAGE_PURPOSE.DECORATIVE}.
     */
    alt?: string | null
  }
}

export type AnyChoice = Choice | IconChoice | ImageChoice

export enum BUTTON_CHOICE_LAYOUT_TYPE {
  ROW = 'row',
  STACK = 'stack',
  CHIP = 'chip'
}
